import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { nriPageMeta, nriSchema } from 'components/common/schema'
import Template from 'components/cases/nri'

const Nri: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...nriPageMeta} />
      <JsonLd data={nriSchema} />
      <Template />
    </>
  )
}

export default Nri
